// Contains all of the action types
export const GET_TIMELINE = 'GET_TIMELINE'
export const CREATE_HASH = 'CREATE_HASH'
export const SCROLL_TO = 'SCROLL_TO'
export const GET_ISFULLSCREEN = 'GET_ISFULLSCREEN'
export const GET_TIMELINE_NAMES = 'GET_TIMELINE_NAMES'